import { loadScript } from './utils';
import Filter from './filters';

const filters = new Filter();

const initFilters = () => {
	if ( filters.settings.container.length )  {
		filters.init();

		$('.js-filter').on('click', function() {
			const $this = $(this);
			const filter = $this.data('filter');

			$this
				.parent()
					.addClass('active')
				.siblings()
					.removeClass('active');

			if ( filter == '*' ) {
				filters.filterReset();
			} else {
				filters.filterByClass(filter);
			}
		});

		$('.js-filter-select').on('change', function() {
			const filter = $(this).val();

			if ( filter == '*' ) {
				filters.filterReset();
			} else {
				filters.filterByClass(filter);
			}
		});

		$('.js-filter-checkbox').on('change', function() {
			filters.filterByCustom(getFormValues($('.js-filters')));
		});
	}
}

const getFormValues = ($container) => {
	let filterClasses = [];
	$container.find('.js-filter-checkbox input').each(function() {
		const $this = $(this);
		const val = $this.val();

		if ($this.prop('checked') ) {
			filterClasses.push(val);
		}
	});

	filterClasses = filterClasses.length === 0 ? '*' : filterClasses.join(' ');
	return {
		multipleClass: {
			classes: filterClasses,
		},
	};
}

export default function fitlersUI() {
	loadScript('isotopeScript', window.isotopeScript, function() {
		return new Promise((resolve, reject) => {
			initFilters()

			resolve();
		})
	})
}
